import { useQuery, gql } from '@apollo/client';
import { flattenObj } from '../../util/flattenObj';
import { AuthUserState } from '../../context/AuthUserProvider';

// Online Continent (Seed the Map slice C): the online-only shops that live on the
// Antarctica overlay. They have no map location, so they are fetched here without
// bounds (a small, capped set) and positioned client-side in MapboxLe.
export const GET_ONLINE_STOREFRONTS = gql`
  query getOnlineStorefronts($limit: Int, $userId: ID, $skip: Boolean!) {
    storeFronts(
      filters: {
        and: [
          { onlineOnly: { eq: true } }
          { available: { eq: true } }
          { publishedAt: { notNull: true } }
        ]
      }
      pagination: { limit: $limit }
    ) {
      data {
        id
        attributes {
          name
          reviewAverage
          reviewCount
          claimStatus
          verifiedAt
          originCountry
          logo {
            data {
              id
              attributes {
                url
              }
            }
          }
          image(pagination: { limit: 1 }) {
            data {
              id
              attributes {
                url
              }
            }
          }
          communityReporter {
            data {
              id
              attributes {
                username
                name
              }
            }
          }
          saved_storefronts(filters: { user: { id: { eq: $userId } } }) @skip(if: $skip) {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const useGetOnlineStorefronts = () => {
  // Match the main map query's pattern: the public role can't read
  // saved-storefront rows, so skip that populate entirely when there's no
  // logged-in user - otherwise the whole query 403s and the Online Continent
  // goes empty for logged-out visitors. Signed-in users get only their own saves.
  const { authUser } = AuthUserState();
  const userId = authUser?.id || null;
  const { data, loading, error, refetch } = useQuery(GET_ONLINE_STOREFRONTS, {
    variables: { limit: 500, userId, skip: !userId }
  });
  const onlineStorefronts = flattenObj(data?.storeFronts) || [];
  return { onlineStorefronts, loading, error, refetch };
};
